import * as Sentry from '@sentry/browser';

export default ({ app }) => {
  if (process.env.SENTRY_DSN) {
    Sentry.init({
      app,
      release: process.env.APP_VERSION,
      dsn: process.env.SENTRY_DSN,
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
};
